export default __webpack_public_path__ + "static/media/libraryPaintingOpen.c7cb3094.jpg";